import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import CustomBreadcrumbs from '../Breadcrumb';
import { useNavigate } from 'react-router-dom';
import { getAllPV_plans } from '../../ReduxStore/CreatePlanSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const PVPlanView = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Physical Verification', href: '/physical-verification' },
    ];

    const [loading, setLoading] = useState(true);
    const [allplans, setAllplans] = useState([]);
    const Role = localStorage.getItem("userRole");



    const planHandler = async (plan) => {
        if (Role === 'admin' || Role === 'supplier') {
            const date = plan.start_date;
            const formattedDate = new Date(date).toISOString().split('T')[0] + 'T00:00:00';
            navigate(`/physical-verification/plan-overview/vendor/${plan.vendor_details.vendor}/${plan.id}/${formattedDate}`)
        } else {
            toast.info("You don't have access to do this activity!")
        }
    }


    const getAllplans = async () => {
        try {
            const action = dispatch(getAllPV_plans());
            const res = await action.unwrap();
            setAllplans(res.result.pv_plan);
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }

    }

    useEffect(() => {
        const fetchData = async () => {
            await getAllplans();
            setLoading(false);
        };
        fetchData();
    }, [])



    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Plan Overview
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Plan Overview" />
                </Box>
                <Box>
                    {allplans && allplans.length === 0 ? (
                        <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                            <Typography variant="h5">No Plan created</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={3}>
                            {allplans && allplans.map((plan, index) => (
                                <Grid item className='PM' xs={12} sm={3} key={index}>
                                    <div className='card' onClick={() => { planHandler(plan) }}
                                    >
                                        <p>Supplier Name:{plan.vendor_details.vendor_description
                                        }</p>
                                        <p>Vendor Code: {plan.vendor_details.vendor}</p>
                                        <p>Vendor Location: {plan.vendor_details.location}</p>
                                        <h4>Physical Verification</h4>
                                        <p>Frequency: {plan.frequency}</p>
                                        <p>{plan.original_date}</p>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    )
                    }

                </Box>
                <ToastContainer />
            </Container>
        </Layout>
    );
};

export default PVPlanView;
